angular
  .module 'gym.components'
  .directive 'contactsWidget', ->
    restrict: 'EA'
    template: require('templates/components/dashboard/contacts_widget.html.slim')
    scope:
      privacyModeEnabled: '='
      setLastRefreshedTimestamp: '&'
    controller: ($scope, $rootScope, Dashboard, Members) ->
      $scope.isLoading = true
      $scope.$on 'dashboard:refresh', () ->
        load()

      load = ->
        Dashboard.customGET('contacts').then (data) ->
          $scope.isLoading = false
          $scope.data = data
          $scope.setLastRefreshedTimestamp(timestamp: data.last_cache_refresh)

      load()
